import { useQuery } from '@tanstack/react-query';
import { getGoTuFeedback } from '../../../../../services/users';

export const useGoTuFeedback = (id) => {
  const { data, isLoading } = useQuery({
    queryKey: ['USERS/GOTU-FEEDBACK', id],
    queryFn: () => getGoTuFeedback(id),
    retry: false,
    initialData: [],
  });

  return {
    data,
    isEmpty: data.length === 0,
    isLoading,
  };
};
